import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Dark-first site; keep theme provider for shadcn/sonner */}
    <App />
  </React.StrictMode>,
);
